<div class="w-100 h-100 m-auto">
    <div class="row" style="padding-top: 25px;padding-bottom: 25px;">
        <div class="col-md-12">
            <label class="header_text mb-3">
                {{$t('shared.providerUpdateinfo')}}
            </label>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12">
            <div class="card card_layout">
                <div class="card-body card_body_layout">
                    <div class="row">
                        <div class="col-md-4 mb-3">
                            <div class="form-group">
                                <label>{{$t('shared.providerName')}}</label>
                                <div class="input-group mb-3">
                                    <input class="form-control"
                                           type="text"
                                            v-model="provider.name"/>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4 mb-3">
                            <div class="form-group">
                                <label>{{$t('shared.enterpriseUnifiedNumber')}}</label>
                                <input class="form-control" v-model="provider.enterpriseUnifiedNumber" type="text" @keydown="blockSpaces"
                                    @paste="sanitizePaste($event, 'enterpriseUnifiedNumber')" @input="stripSpaces('enterpriseUnifiedNumber')" />
                            </div>
                        </div>
                        <div class="col-md-4 mb-3">
                            <div class="form-group">
                                <label>{{$t('shared.accreditationNumber')}}</label>
                                <div class="input-group mb-3">
                                    <input class="form-control" type="text"   v-model="provider.accreditationNumber" @keydown="blockSpaces"
                                        @paste="sanitizePaste($event, 'accreditationNumber')" @input="stripSpaces('accreditationNumber')" />
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4 mb-3">
                            <div class="form-group">
                                <label>{{$t('shared.taxNumber')}}</label>
                                <div class="input-group mb-3">
                                    <input class="form-control" type="text"   v-model="provider.taxNumber" @keypress="isNumberField($event)"
                                        @keydown="blockSpaces" @paste="sanitizePaste($event, 'taxNumber')" @input="stripSpaces('taxNumber')" />
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4 mb-3">
                            <div class="form-group">
                                <label>{{$t('shared.integrationApiKey')}}</label>
                                <div class="input-group mb-3">
                                    <input class="form-control" type="text" v-model="provider.integrationApiKey" />
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4 mb-3">
                            <div class="form-group">
                                <label>{{$t('shared.integrationBaseURL')}}</label>
                                <div class="input-group mb-3">
                                    <input class="form-control" type="text" v-model="provider.integrationBaseURL" disabled />
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="row">
                                <div class="col-md-6 col-12 pt-3">
                                    <div class="form-group">
                                        <div class="input-group mb-3">
                                            <input type="file" ref="providerFile" hidden accept=".pdf,.doc,.docx"
                                                @change="onProviderFilePicked" />
                                        <input :placeholder="$t('shared.addAttachment')" @click="onPickProviderFile"
                                               class="form-control border-right-0 border-left" readonly
                                               style="cursor: pointer;"
                                               v-model="selectedProviderFileName"
                                               type="text" />
                                        </div>
                                    </div>
                                </div>
                        
                                <div class="col-md-4 pt-3">
                                    <div class="form-group">
                                        <v-select v-model="selectedProviderAttachmentCategory" :items="providerAttachmentCategoryList"
                                            :label="$t('shared.addCategory')" item-text="name" item-value="id" solo attach />
                                    </div>
                                </div>
                        
                                <div class="input-group-prepend pt-3">
                                    <span style="padding: 4px;">
                                        <button :disabled="!canAddProviderAttachment" @click="addProviderAttachment" class="btn btn-primary">
                                            {{$t('shared.add')}}
                                        </button>
                                    </span>
                                </div>
                        
                                <div class="col-md-12" style="width:100%;">
                                    <label class="d-inline-flex align-items-center" style="justify-content:flex-start; gap:4px;">
                                        {{$t('shared.attachment')}}
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-icon v-bind="attrs" v-on="on" small class="align-middle"
                                                    :style="{ color: 'var(--color-Main)' }">
                                                    mdi-information-outline
                                                </v-icon>
                                            </template>
                                            <span
                                                style="white-space: pre-line">{{$t('shared.theMaximumSizeForTheAttachmentIs3Megabytes')}}</span>
                                        </v-tooltip>
                                    </label>
                        
                                    <ul class="list-group list_Sender scrollbar" style="width:100%; max-width:100%; margin:0; padding:0;">
                                        <li class="list-group-item" v-if="providerUploadedAttachments.length > 0"
                                            v-for="(item, index) in providerUploadedAttachments" :key="item.categoryId + '-' + index"
                                            style="display:flex; align-items:flex-start; justify-content:space-between; gap:12px; width:100%; padding:12px 16px;">
                                            <div style="flex:1 1 auto;">
                                                <span class="box-name" style="display:inline; white-space:normal; overflow-wrap:anywhere;">
                                                    {{ item.fileName }}
                                                </span>
                                                <span class="box-name" style="vertical-align:middle;"> — {{ item.categoryName }}</span>
                                            </div>
                                            <div style="display:flex; align-items:center; gap:12px; flex:0 0 auto; margin-top:2px;">
                                                <i class="fas fa-sync-alt" title="Replace" @click.stop="replaceProviderAttachment(index)"
                                                    style="cursor:pointer;"></i>
                                                <i class="far fa-trash-alt Icon_delete" title="Delete"
                                                    @click.stop="deleteProviderAttachment(index)" style="cursor:pointer;"></i>
                                            </div>
                                        </li>
                                        <li class="list-group-item" v-if="providerUploadedAttachments.length == 0"
                                            style="width:100%; padding:12px 16px;">
                                            {{$t('shared.noAttachments')}}
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12 mt-5">
                            <div class="form-row justify-content-end align-items-center">
                                <div class="col-auto mx-3">
                                    <router-link to="/ProviderSupport" tag="a" class="link_secondary">{{$t('shared.no')}}</router-link>
                                </div>
                                <div class="col-auto">
                                    <button class="btn btn-success px-5 py-2" :disabled="!isValid" @click="showeditProviderDialog">{{$t('shared.save')}}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="text-xs-center">
        <v-dialog v-model="editProviderDialog" width="554">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    {{$t('shared.updateInput')}}
                    <div class="close__dialog">
                        <i class="fas fa-times" @click="hideEditProviderDialog"></i>
                    </div>
                </v-card-title>
                <v-card-text class="text-center">
                    <p class="mt-3">
                        {{$t('shared.updateProviderInputText')}}
                    </p>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <div class="form-row justify-content-end align-items-center">
                        <div class="col-auto mx-3">
                            <a class="link_danger" @click="hideEditProviderDialog">
                                {{$t('shared.cancel')}}
                            </a>
                        </div>
                        <div class="col-auto">
                            <button class="btn btn-danger px-5 py-2" @click="editProvider">{{$t('shared.yes')}}</button>
                        </div>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</div>

